import { FC } from "react";
import DOMPurify from "dompurify";
import cn from "classnames";
import { cleanHtml, convertNumberedLinesToList, isRTLText, removeDuplicateBlocks } from "./utils";

interface RichTextUnstyledProps {
  html: string;
  className?: string;
}

const RichTextUnstyled: FC<RichTextUnstyledProps> = ({ html, className }) => {
  if (!html) return null;

  const htmlWithBreaks = html.replaceAll("\\n", "<br>");

  const cleaned = cleanHtml(htmlWithBreaks);

  const deduped = removeDuplicateBlocks(cleaned);

  const htmlWithLists = convertNumberedLinesToList(deduped);

  const sanitizedHtml = DOMPurify.sanitize(htmlWithLists, {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS: [
      "p", "br", "strong", "b", "em", "i", "u", "span",
      "ul", "ol", "li", "a",
      "table", "thead", "tbody", "tr", "td", "th",
      "div"
    ],
    ALLOWED_ATTR: [
      "href", "title", "target", "rel", "class", "style",
      "border", "rowspan", "colspan"
    ],
  });

  const isRTL = isRTLText(sanitizedHtml);

  return (
    <div
      className={cn(className)}
      dir={isRTL ? "rtl" : "ltr"}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default RichTextUnstyled;
